// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('UserProfileFeedEmptyCollectionCard')

function EmptyCollectionCard(props) {
  return tag('div', {
    className: classNames(
      props.className,
      bem.block()
    ),
    onClick: props.onAddUrlClick
  },
    tag('div', {
      className: bem.element('circle')
    }),
    tag('div', {
      className: bem.element('column')
    },
      tag('div', {
        className: bem.element('heading')
      },
        'Add links to create new collections'
      ),
      tag('div', {
        className: bem.element('subheading')
      },
        tag('div', {
          className: bem.element('button')
        }),
        'Get started!'
      )
    )
  )
}

EmptyCollectionCard.propTypes = {
  className: PropTypes.string,
  onAddUrlClick: PropTypes.func
}

module.exports = EmptyCollectionCard
